import { useState } from 'react';
import { Box, Button, Divider, Flex } from '@chakra-ui/react';
import Modal from '../../modal/Modal';
import majsList from './majs/majsList';

const ManageMajs = () => {
  const changeLogLastVersion = majsList.length;

  const [displayOld, setDisplayOld] = useState(false);

  const modalOptions = {
    displayMajs: {
      component: (
        <Flex gap={3} direction='column'>
          {!displayOld ? (
            <>
              {majsList[changeLogLastVersion - 1]}
              <Button onClick={() => setDisplayOld(true)}>
                Afficher les ancienne mises à jour
              </Button>
            </>
          ) : (
            <Box>
              {majsList.reverse().map((maj, idx) => (
                <>
                  {maj}
                  {idx !== majsList.length && <Divider my={3} />}
                </>
              ))}
            </Box>
          )}
        </Flex>
      ),
      title: 'Mises à jour',
    },
  };

  return <Modal options={modalOptions} />;
};

export default ManageMajs;
